export default "__VITE_ASSET__DZD8HWeW__"